import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsOneStep.AddPersonWizard.SendInvitation', {
    message: "If you don't have verification details - you can request {email} to provide them separately",
    sendInvitation: 'Send invitation',
    confirmTitle: 'Invitation',
    confirmMessage:
        'You are going to send invitation to the {email}. This user will be asked to provide verification details.',
    confirmCancel: 'Back',
    confirm: 'Submit and Send invitation',
    invitationSent: 'Invitation successfully sent',
});
